import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import { useMatches, Link, useLocation } from 'react-router-dom';

const BreadcrumbComponent = () => {
  const mainText = useColorModeValue('white', 'gray.200');
  const secondaryText = useColorModeValue('white', 'gray.200');
  const matches = useMatches();
  const { state } = useLocation();

  return (
    <Box mb={{ sm: '8px', md: '0px' }}>

      <Breadcrumb>
        <BreadcrumbItem color={mainText}>
          <BreadcrumbLink as={Link} to="/" color={secondaryText}>
            Home
          </BreadcrumbLink>
        </BreadcrumbItem>

        {matches.slice(2).filter((i) => !i.data?.hidden).map((path, id) => (
          <BreadcrumbItem color={mainText} key={id}>
            <BreadcrumbLink as={Link} to={path.data?.to || path.pathname} color={mainText}>
              {path.data?.name || 'Submize'}
            </BreadcrumbLink>
          </BreadcrumbItem>
        ))}

      </Breadcrumb>
      <Text color={mainText} fontWeight="bold">
        {state?.title || 'Submize'}
      </Text>
    </Box>

  );
};

export default BreadcrumbComponent;
